module.exports = {

  title: '',

  /**
   * @type {boolean} true | false
   * @description Whether fix the header
   */
  fixedHeader: false,

  /**
   * @type {boolean} true | false
   * @description Whether show the logo in sidebar
   */
  sidebarLogo: false,

  appid: '5ae2c435e5f35',
  app_secret: '0e7977d268da82c5499502fbfff1b425'
}



// WEBPACK FOOTER //
// ./src/settings.js